import { isObject } from '../../util/guards';
import { isRouteValid } from '../routes/utils';
import { UrlChangedDuplexerEvent } from './types';

export function isUrlChangedDuplexerEvent(value: unknown): value is UrlChangedDuplexerEvent {
  if (!isObject(value)) {
    return false;
  }

  if (typeof value.id !== 'string') {
    return false;
  }

  const { addedUrl, replacedUrl, removeLast } = value;

  return (
    (typeof addedUrl === 'string' && isRouteValid(addedUrl)) ||
    (typeof replacedUrl === 'string' && isRouteValid(replacedUrl)) ||
    typeof removeLast === 'boolean'
  );
}
